<div class="row">
  <div class="col-xs-12 modify-title step question">
    <a class="close-modal-trigger">
      <span class="icon icon-arrow-left" id="btnGoBack" (click)="closeSwqModal()"></span>
    </a>
    <p class="text-10-m-regular white"></p>
    <span class="icon icon-cancel" id="btnCancel" data-no-close-modal="true" (click)="discardSwqModal()"></span>
  </div>

  <div class="col-xs-12 col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3 wrapper-question">
    <p class="title-d-section text-06-d-demibold white hidden-xs" *ngIf="sectionDetails">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">{{ sectionDetails.SerialNumber }}. {{ sectionDetails.Title }}</font>
      </font>
    </p>

    <div class="edit-question">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
